import React, { useEffect, useState } from 'react'
import Layout from '../../../Components/Layout'
import SearchEvents from '../../../Components/User/Events/SearchEvents'
import useHttpHook from '../../../Hooks/HttpHook'
import { GetEventByTitle } from '../../../utils/ApiConstant'

const SearchEventPage = () => {
    const [loading, sendRequest, error] = useHttpHook()
    const query = new URLSearchParams(window.location.search)
    const searchTitle = query.get('title')
    const [title, setTitle] = useState(searchTitle)
    const [events, setEvents] = useState([])

    useEffect(() => {
        getEvents()
    }, [searchTitle])


    const getEvents = async () => {
        try {
            const res = await sendRequest(`${GetEventByTitle}?title=${title}`, { method: 'get' })
            if (res.status === 1) {
                setEvents(res.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <Layout
            Heading={title || "Search"}
            SubHeading={searchTitle ? `Results for “${searchTitle}”` : "Search results for events"}
            activeMenuId="search"
        >
            <SearchEvents loading={loading} error={error} eventList={events} />
        </Layout>
    )
}

export default SearchEventPage